import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';
import { CrmOperationType } from '../../../../../../../api/types/crm/payments/crm-payments-entity';
import { PaymentMethodsDb } from '../../../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

export type CrmPaymentServicePayloadItem =
  | { serviceName: string; units: number; unitPrice: number }
  | {
      paymentServiceId: number;
      paymentServicePriceId: number;
      units: number;
    };

export const createCrmPaymentOperation = async (
  accountId: number,
  payload: {
    branchId: number | null;
    paymentAmount: number;
    operationType: CrmOperationType;
    paymentMethodType: PaymentMethodsDb;
    services: CrmPaymentServicePayloadItem[];
    accountingDocumentSubject?: string | null;
    recipientName?: string;
    /** CRM account registration number — sent as backend `identifierId` */
    identifierId: string;
    phoneNumber: string;
    issuedFor?: string;
    note?: string;
    paymentMethodDetails?:
      | { creditCardTokenId: number; numberOfInstallments: number }
      | {
          bankNumber: string;
          branchNumber: string;
          accountNumber: string;
          dueDate: string;
          referenceId: string;
        }
      | {
          bankNumber: string;
          branchNumber: string;
          accountNumber: string;
          transferDate: string;
          referenceId: string;
        };
    // Backend Joi requires this when operationType === Refund and forbids it
    // otherwise — we conditionally spread the key into the body below so it
    // never appears for non-refund flows.
    originalCrmPaymentId?: number;
  },
  setLoading: (loading: boolean) => any,
  onSuccess: () => void,
) => {
  try {
    const identifierId = String(payload.identifierId ?? '').trim();
    const phoneNumber = String(payload.phoneNumber ?? '').trim();
    if (!identifierId) {
      toast.warn('יש למלא מספר רישום');
      return;
    }
    if (!phoneNumber) {
      toast.warn('יש למלא מספר טלפון');
      return;
    }

    setLoading(true);

    const res = await appApi.createCrmPayment(accountId, {
      branchId: payload.branchId,
      paymentAmount: payload.paymentAmount,
      operationType: payload.operationType,
      paymentMethodType: payload.paymentMethodType,
      services: payload.services,
      identifierId,
      phoneNumber,
      ...(payload.paymentMethodDetails
        ? { paymentMethodDetails: payload.paymentMethodDetails }
        : {}),
      ...(payload.accountingDocumentSubject != null &&
      String(payload.accountingDocumentSubject).trim() !== ''
        ? {
            accountingDocumentSubject: String(
              payload.accountingDocumentSubject,
            ).trim(),
          }
        : {}),
      ...(payload.recipientName != null && String(payload.recipientName).trim()
        ? { recipientName: String(payload.recipientName).trim() }
        : {}),
      ...(payload.issuedFor != null && String(payload.issuedFor).trim()
        ? { issuedFor: String(payload.issuedFor).trim() }
        : {}),
      ...(payload.note != null && String(payload.note).trim()
        ? { note: String(payload.note).trim() }
        : {}),
      ...(payload.originalCrmPaymentId != null
        ? { originalCrmPaymentId: payload.originalCrmPaymentId }
        : {}),
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('התשלום נוצר בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
